import { render, staticRenderFns } from "./posisi.vue?vue&type=template&id=743754fa"
import script from "./posisi.vue?vue&type=script&lang=js"
export * from "./posisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports